export default __webpack_public_path__ + "static/media/add-folder-icon.7ca41669.svg";